import Service from "../Service";
const resource = "TasProducerHistory/";

export default {
  paginationAdvanceMoney(parameters, requestID) {
    return Service.post(resource + "paginationAdvanceMoney", parameters, {
      params: { requestID },
    });
  },
  paginationAdvanceSupplies(parameters, requestID) {
    return Service.post(resource + "paginationAdvanceSupplies", parameters, {
      params: { requestID },
    });
  },
  liquidationSummaryByProducer(parameters, requestID) {
    return Service.post(resource + "liquidationSummaryByProducer", parameters, {
      params: { requestID },
    });
  },
};
